export default __webpack_public_path__ + "static/media/BoyPage2.8ea5503b.txt";